
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import type { ArticleFormValues } from "./ArticleEditor";
import { Control } from "react-hook-form";

interface Props {
  control: Control<ArticleFormValues>;
}

export default function ArticleEditorTitle({ control }: Props) {
  return (
    <FormField
      control={control}
      name="title"
      rules={{ required: "Title is required" }}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-white/90">Title</FormLabel>
          <FormControl>
            <Input placeholder="Article title" {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
